import { Base64 } from "js-base64";

import WebKeys from "./WebKeys";

/**
 * Extraen del token de datos indicado el objeto correspondiente a los datos.
 * No se valida que la firma sea válida, se confía en lo que hay. (Básicamente
 * porque no vamos a usar aquí la clave para validar).
 */
export function extractTokenValue<T>(token: string): T | null {
  const idx = token.indexOf(WebKeys.TOKEN_SEPARATOR);
  if (idx !== -1) {
    const encoded = token.substring(0, idx);
    const value = JSON.parse(Base64.decode(encoded));

    return value;
  }

  return null;
}
